(function () {
  function initTabs(section) {
    section.querySelectorAll('[data-pdp-tabs]').forEach(function (tabs) {
      if (tabs.dataset.underwearTabsReady === 'true') return;
      tabs.dataset.underwearTabsReady = 'true';

      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(tabs.querySelectorAll('[role="tabpanel"]'));
      if (!buttons.length || !panels.length) return;

      function activate(button, shouldFocus) {
        buttons.forEach(function (item) {
          var isActive = item === button;
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.id !== button.getAttribute('aria-controls');
        });

        if (shouldFocus) button.focus();
      }

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          activate(button, false);
        });

        button.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = buttons.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          activate(buttons[nextIndex], true);
        });
      });
    });
  }

  function initUnderwearProduct(section) {
    if (!section || section.dataset.underwearProductReady === 'true') return;
    section.dataset.underwearProductReady = 'true';
    initTabs(section);

    section.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      section.dataset.currentVariantId = String(variant.id || '');
    });

    section.dispatchEvent(new CustomEvent('underwear-product:ready', {
      bubbles: true,
      detail: { sectionId: section.closest('.shopify-section') && section.closest('.shopify-section').id }
    }));
  }

  function init(root) {
    (root || document).querySelectorAll('[data-underwear-product]').forEach(initUnderwearProduct);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
